var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.shouldShow,
      expression: "shouldShow"
    }],
    class: ['phoenix-keyboard-wrapper', ("keyboard-" + (_vm.keyboardType))],
    attrs: {
      "id": "phoenix-keyboard-wrapper"
    }
  }, [_c('div', {
    class: ['ExternalKeyboard', {
      outline: _vm.showOutline,
      disabled: _vm.keyboardLocked
    }]
  }, _vm._l(_vm.displayKeys, function (row) {
    return _c('div', {
      key: row.name,
      class: [("row " + (row.name)), _vm.theme]
    }, _vm._l(row.keys, function (key) {
      return _c(_vm.getKwtKey(key), {
        key: key.name,
        tag: "component",
        attrs: {
          "name": key.name,
          "character": key.character,
          "alt": key.alt,
          "shift": key.shift,
          "hold-hand": key.hold,
          "row": row.name
        }
      });
    }), 1);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }